import { useState } from 'react';

const useStock = () => {
  const [openRangeDialog, setOpenRangeDialog] = useState(false);
  const [openHubDialog, setOpenHubDialog] = useState(false);
  const [openTransferDialog, setOpenTransferDialog] = useState(false);
  const [hub, setHub] = useState(null);
  const [isTransfer, setIsTransfer] = useState(false);
  const [isUnassign, setIsUnassign] = useState(false);

  const handleOpenRangeDialog = ({ isTransfer = false, isUnassign = false }) => {
    setIsTransfer(isTransfer);
    setIsUnassign(isUnassign);
    setOpenRangeDialog(true);
  };
  const handleCloseRangeDialog = () => {
    setOpenRangeDialog(false);
  };

  const handleOpenTransferDialog = () => {
    setOpenTransferDialog(true);
  };
  const handleCloseTransferDialog = () => {
    setOpenTransferDialog(false);
  };

  const handleChangeHub = (value) => {
    setHub(value);
  };

  const handleOpenHubDialog = () => {
    setOpenHubDialog(true);
  };
  const handleCloseHubDialog = () => {
    setOpenHubDialog(false);
  };
  const [page, setPage] = useState(0);

  const [selected, setSelected] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleSelectAllClick = useCallback(
  //   (event) => {
  //     if (event.target.checked) {
  //       const newSelecteds = data?.map((n) => n.id);
  //       setSelected(newSelecteds);
  //       return;
  //     }
  //     setSelected([]);
  //   },
  //   [data]
  // );

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const resetSelectedList = () => {
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    handleClick,
    handleChangePage,
    handleChangeRowsPerPage,
    handleOpenRangeDialog,
    handleCloseRangeDialog,
    resetSelectedList,
    handleCloseHubDialog,
    handleOpenHubDialog,
    handleChangeHub,
    page,
    rowsPerPage,
    selected,
    openRangeDialog,
    openHubDialog,
    hub,
    handleOpenTransferDialog,
    handleCloseTransferDialog,
    isTransfer,
    isUnassign,
    openTransferDialog,
  };
};

export { useStock };
